import { IconComponent } from './types';

const CropTemplateIcon: IconComponent = (props) => (
  <svg
    width={12}
    height={9}
    viewBox="0 0 12 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.932 7.741A4.987 4.987 0 0 0 2.09 5.085c1.793.35 3.15 1.732 3.376 3.415H.5v-.125h3.607l-.175-.634Zm4.612.634h2.95V8.5H7.672a5.966 5.966 0 0 0-.109-.728 5.474 5.474 0 0 0-.321-1.01 4.335 4.335 0 0 1 2.666-1.675A5.014 5.014 0 0 0 8.063 7.74l-.179.635h.66Zm-1.76-4.18A4.106 4.106 0 0 1 8.679 2.15a6.05 6.05 0 0 0-.881 1.428 6.607 6.607 0 0 0-1.012.615ZM5.091 2.692c-.15.263-.284.54-.395.826a6.278 6.278 0 0 0-.398-1.963c.325.336.593.72.793 1.137Z"
      stroke="#212121"
    />
  </svg>
);

export default CropTemplateIcon;
